module.exports = __webpack_public_path__ + "static/GT-Super-Text-Book-Italic-977f03b06c40e897840658c7bbe3199e.woff";